/**
 * Per-browser dismissal for the admin-managed site notice (`AD-SN01`),
 * generalizing `features/playground/lib/engine-notice.ts`'s single-id
 * `localStorage` pattern: one key holds the last-dismissed notice id, so a
 * rewritten notice (a new `id`, since the backend recomputes it from the text)
 * naturally shows again without a key rename.
 */

export const SITE_NOTICE_DISMISSAL_KEY = "progsity:site-notice:dismissed";
const KEY = SITE_NOTICE_DISMISSAL_KEY;

export function isSiteNoticeDismissed(id: string): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(KEY) === id;
  } catch {
    return false;
  }
}

export function persistSiteNoticeDismissed(id: string): void {
  try {
    window.localStorage.setItem(KEY, id);
  } catch {
    /* quota / private mode: the bar comes back next visit, which is fine */
  }
}
